import { MutationTree } from 'vuex';
import { AlertBanner, AlertBannerState } from './types';

export const mutations: MutationTree<AlertBannerState> = {
  setAlertBanners(state, payload: AlertBanner[]) {
    state.alertBannerOptions = payload;
  },
};
